module.exports = __webpack_public_path__ + "img/front.9799641d.png";